@if (manager) {
  <div class="person">
    <div class="image-container">
      @if (userImageSrc) {
        <div
          class="profile-image"
          [ngStyle]="{ background: 'url(' + userImageSrc + ')' }"></div>
      } @else {
        <mat-icon class="person">person</mat-icon>
      }
    </div>
    <div class="info">
      <div class="name">
        <p class="bold">{{ manager | name }}{{ position ? ' (' + position + ')' : '' }}</p>
        <coin-v2-country-flag
          size="s"
          [country]="manager.placeOfAction"
          [showTooltip]="true"></coin-v2-country-flag>
      </div>
      <div class="location">
        <mat-icon class="place-icon">place</mat-icon>
        <p>{{ manager?.city }}, {{ $safeNavigationMigration(manager?.placeOfAction) | uppercase }}</p>
      </div>
    </div>
  </div>
}
